import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Calling from "../../api/Calling";
import { TextField, Button, InputAdornment, CircularProgress } from "@mui/material";
import { Mail, KeyRound, SendHorizonal } from "lucide-react";
import AuthShell, { darkFieldSx, authButtonSx } from "./AuthShell";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ForgetPw() {
    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const validate = () => {
        if (!email.trim()) return "Email is required";
        if (!EMAIL_RE.test(email.trim())) return "Enter a valid email address";
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const v = validate();
        if (v) { setError(v); return; }
        setError("");
        setLoader(true);
        const body = {
            a_email: email
        }
        try {
            const resp = await Calling.ForgetPw(body); // Example function, replace with actual
            const { status, message, token } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                localStorage.setItem('forgetPw', token);
                localStorage.removeItem('forgetOtpVerified'); // fresh flow → require OTP again
                navigate("/admin/panel/forget/otp"); // Replace with the actual route
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
        // Replace with your OTP verification logic

    };

    return (
        <>
            <title>Email Verification</title>

            <AuthShell
                icon={<KeyRound size={30} />}
                title="Forgot Password"
                subtitle="Enter your email to receive a verification code"
            >
                <form onSubmit={handleSubmit} noValidate className="flex flex-col gap-4">
                    <TextField
                        label="Enter Email"
                        type="email"
                        value={email}
                        onChange={(e) => { setEmail(e.target.value); if (error) setError(""); }}
                        required
                        fullWidth
                        error={!!error}
                        helperText={error}
                        sx={darkFieldSx}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Mail size={18} color="rgba(255,255,255,0.55)" />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disableElevation
                        disabled={loader}
                        sx={authButtonSx}
                        startIcon={loader ? <CircularProgress size={18} color="inherit" /> : <SendHorizonal size={18} />}
                    >
                        {loader ? "Sending..." : "Send Code"}
                    </Button>
                </form>
            </AuthShell>
        </>
    );
}
